if (!customElements.get('rc-hero-slideshow')) {
  customElements.define('rc-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
      this.index = 0;
      this.userPaused = false;
      this.editorPaused = false;
      this.hovered = false;
      this.touchStart = null;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayButton = this.querySelector('[data-autoplay]');
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-autoplay')) {
          this.userPaused = !(this.userPaused || this.editorPaused);
          this.editorPaused = false;
          this.schedule();
          return;
        }
        if (button.hasAttribute('data-previous')) this.show(this.index - 1);
        if (button.hasAttribute('data-next')) this.show(this.index + 1);
        if (button.hasAttribute('data-go-to')) this.show(Number(button.dataset.goTo));
      }, options);
      this.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1 || event.target.closest('a, button')) return;
        this.clearTimer();
        this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', (event) => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
        else this.schedule();
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (this.isConnected) this.schedule();
      }), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motionPreference.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index !== -1) { this.editorPaused = true; this.show(index); }
      }, options);
      if (this.slides.length) { this.show(0); this.setAttribute('data-ready', ''); }
    }
    disconnectedCallback() {
      this.clearTimer();
      this.abortController?.abort();
    }
    clearTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    schedule() {
      this.clearTimer();
      if (this.autoplayButton) {
        const paused = this.userPaused || this.editorPaused;
        this.autoplayButton.hidden = this.motionPreference.matches;
        this.autoplayButton.setAttribute('aria-label', paused ? this.autoplayButton.dataset.playLabel : this.autoplayButton.dataset.pauseLabel);
        this.autoplayButton.querySelector('[data-autoplay-icon]').textContent = paused ? '▶' : 'Ⅱ';
      }
      if (!this.isConnected || this.slides.length < 2 || this.userPaused || this.editorPaused ||
          this.motionPreference.matches || document.hidden || this.hovered || this.touchStart ||
          this.contains(document.activeElement)) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), 3000);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const hidden = position !== this.index;
        if (hidden && slide.contains(document.activeElement)) this.querySelector('[data-next]')?.focus();
        slide.hidden = hidden;
        slide.inert = hidden;
        slide.setAttribute('aria-hidden', String(hidden));
      });
      this.dots.forEach((dot, position) => {
        if (position === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.schedule();
    }
  });
}
